/// <amd-module name="VSSUI/Components/ButtonGroup/ButtonGroup" />
import * as React from "react";

import { css } from "VSSUI/Util";

import { IButtonGroupProps } from "./ButtonGroup.Props";

export const ButtonGroup = (props: IButtonGroupProps & Readonly<{ children?: React.ReactNode }>) => {
    return (
        <div className={css(props.className, "bolt-button-group flex-row")} role={props.role}>
            {props.children}
        </div>
    );
};
